import type React from 'react';
import { Box, Text } from 'braid-design-system';
import ErrorAlert from 'src/components/common/ErrorAlert';

interface PageAlertProps {
  children: React.ReactNode;
}

const PageAlert: React.FC<PageAlertProps> = ({ children }) => (
  <Box
    padding="large"
    paddingBottom="xxlarge"
    background="surface"
    boxShadow="small"
  >
    <Box display="inlineBlock">
      <ErrorAlert>
        <Text>{children}</Text>
      </ErrorAlert>
    </Box>
  </Box>
);

export default PageAlert;
